<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      General Clinical Information EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="fieldName">
          In EMR 
        </div>
        <br>
        <div
          v-if="heightWeightListCombined.length === 0"
        >
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                disabled
                label="Height (cm)"
                class="highlightField"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                disabled
                label="Measurement Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Weight (kg)"
                class="highlightField"
              />
            </div> 

            <!-- <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                disabled
                label="Measurement Date"
              />
            </div> -->
          </div>
        </div>
        <div
          v-for="( item ) in heightWeightListCombined"
          :key="item"
        >
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.height"
                disabled
                label="Height (cm)"
                :class="{ highlightField: isDifferentHeight( heightWeightListCombined, heightWeightListOATS ) }"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.measurementDateHeight"
                disabled
                label="Measurement Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="item.weight"
                disabled
                label="Weight (kg)"
                :class="{ highlightField: isDifferentWeight( heightWeightListCombined, heightWeightListOATS ) }"
              />
            </div> 

            <!-- <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.measurementDateWeight"
                disabled
                label="Measurement Date"
              />
            </div> -->
          </div>
        </div>
        <br>
        <div class="fieldName">
          In OATS
        </div>
        <br>
        <div
          v-for="( item ) in heightWeightListOATS"
          :key="item"
        >
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.height"
                disabled
                label="Height (cm)"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                id="disabled-text"
                v-model="item.measurementDate"
                disabled
                label="Measurement Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="item.weight"
                disabled
                label="Weight (kg)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "ClinicalSectionDetailsWithOATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      //bloodType: this.getBloodType( this.patientBundle ),
      // rhFactor: this.getRHFactor( this.patientBundle ),
      // bloodTypeVerified: this.getBloodTypeVerified( this.patientBundle ),
      // cPRA: this.getCPRA( this.patientBundle ),
      // height: this.getHeight( this.patientBundle ),
      // weight: this.getWeight( this.patientBundle ),
      heightList: this.getHeightList( this.patientBundle ),
      weightList: this.getWeightList( this.patientBundle ),
      heightWeightListCombined: this.getCombinedList( this.getHeightList( this.patientBundle ), this.getWeightList( this.patientBundle ) ),
      heightWeightListOATS: this.getOATSMeasurementsList( this.patientBundleOATS )
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    isDifferentWeight( a, b ) {
      const aWeight = Array.isArray( a ) ? a?.[ 0 ]?.weight ?? null : null;
      const bWeight = Array.isArray( b ) ? b?.[ 0 ]?.weight ?? null : null;

      return aWeight !== bWeight;
    },
    isDifferentHeight( a, b ) {

      const aHeight = Array.isArray( a ) ? a?.[ 0 ]?.height ?? null : null;
      const bHeight = Array.isArray( b ) ? b?.[ 0 ]?.height ?? null : null;

      return aHeight !== bHeight;
    },
    getHeightList( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'vital-signs' ) );
      if ( observation && observation[0] ) {
        let heightList = [];
        for ( let item of observation[0] ) {
          if ( item?.resource?.code?.coding ) {
            for ( let x of item?.resource?.code?.coding ) {
              if ( x.code === '8302-2' && x.system === "http://loinc.org" ) {
                heightList.push( { 'height': item.resource?.valueQuantity?.value , 'measurementDate': item.resource?.effectiveDateTime.substring( 0, 10 ) } );
              }
            }
          }
        }
        // }
        return heightList;
      }
      return [];
    },
    getWeightList( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'vital-signs' ) );
      if ( observation && observation[0] ) {
        let heightList = [];
        for ( let item of observation[0] ) {

          if ( item?.resource?.code?.coding ) {
            for ( let x of item?.resource?.code?.coding ) {
              if ( x.code === '29463-7' && x.system === "http://loinc.org" ) {
                heightList.push( { 'weight': item.resource?.valueQuantity?.value , 'measurementDate': item.resource?.effectiveDateTime?.substring( 0, 10 ) } );
              }
            }

          }
        }
        return heightList;
      }
      return [];
    },
    getCombinedList( heightList, weightList ) {
      //let length = heightList.length > weightList.length ? heightList.length : weightList.length;
      let combinedList = [];

      for( let x=0; x < 1; x++ ) {
        combinedList.push( { 'height' : _.get( heightList[ x ], 'height', '' ), 'measurementDateHeight' : _.get( heightList[ x ], 'measurementDate', '' ), 
        'weight' : _.get( weightList[ x ], 'weight', '' ), 'measurementDateWeight' : _.get( weightList[ x ], 'measurementDate', '' ) } )
       
      }
      return combinedList;
    },
    getOATSMeasurementsList( patientBundleOATS ) {
      let list = [];
      let measurements = patientBundleOATS.measurements;

      if( measurements && measurements[ 0 ] ) {
        for( let item of measurements ) {
          list.push( { 'height': item.height, 'weight': item.weight, 'measurementDate': item.date } )
          break;
        }
      }

      return list;
    }
    
  },
};
</script>

<style scoped>

/* .card {
  height: 340px;
} */

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}


.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}
.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 400px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 800;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

/* :deep(.CoverageClassName .afflo-ds-form-control) {
  width: 360px;
} */

</style>
